import { render, staticRenderFns } from "./popup-captcha.vue?vue&type=template&id=99ba6328"
import script from "./popup-captcha.vue?vue&type=script&lang=js"
export * from "./popup-captcha.vue?vue&type=script&lang=js"
import style0 from "./popup-captcha.vue?vue&type=style&index=0&id=99ba6328&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports